import React from "react";

interface Props {
  message?: string;
}

const NetworkThreatNoDataMsg: React.FC<Props> = ({ message }) => {
  const defaultMessage = "No data available";
  return <div>{message || defaultMessage}</div>;
};

export default NetworkThreatNoDataMsg;
